import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Button, Alert, Card, Row, Col } from 'react-bootstrap';

import { useLoading } from '../components/LoadingProvider';

import { useTranslation } from "react-i18next";

import { getUserLocation } from '../components/getUserLocation';
import { checkEligibility, addUserPlant } from '../services/userPlants/userPlantsService';

import { ProvinceSelect, detectProvinceFromPhone } from '../components/ProvinceSelect';

import onlineShopping from "../assets/online-shopping.gif";


const PlantReminderPage = () => {
    const { plantId } = useParams();
    const navigate = useNavigate();

    const { t, i18n } = useTranslation();

    const [province, setProvince] = useState("");


    const [plant, setPlant] = useState(null);
    const [eligible, setEligible] = useState(false);
    const [potSize, setPotSize] = useState('medium');
    const [mobile, setMobile] = useState('');
    const [reminderChannels, setReminderChannels] = useState(null);
    const [reminderName, setReminderName] = useState('');
    const [reminderNote, setReminderNote] = useState('');

    const { showLoading, hideLoading, toast } = useLoading();

    const [channels, setChannels] = useState({
        sms: false,
        whatsapp: false,
        bale: false,
        // telegram: false,
    });
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(true);

    const [location, setLocation] = useState('-');
    const [weather, setWeather] = useState(null);
    const [lastWateredIndexDay, setLastWateredIndexDay] = useState(-1);



    const BASE_URL = process.env.REACT_APP_BASE_URL;


    const findLocationByPhone = (mob) => {
        const detected = detectProvinceFromPhone(mob);
        if (detected) {
            setProvince(detected);
        }
    };

    useEffect(() => {
        handleLoadLocation();
    }
        , []);


    useEffect(() => {

        showLoading();

        var latLong = {
            lat: 0,
            lon: 0
        };

        if (location && !location.error) {
            latLong = {
                lat: location.latitude || 0,
                lon: location.longitude || 0
            };
        }

        checkEligibility(plantId, latLong)
            .then(data => {
                console.log(data)


                if (data.status == 400 || data.hasError || (data.message && data.message.indexOf('upgrade') != -1 )) {

                    setEligible(false); //   مجاز نیست
                // setLoading(false);
                    setPlant({"message":data.message});
                    return;
                }

                const obj = {
                    id: plantId,
                    name: data.data.name,
                    description: data.data.description,
                    group: data.data.group.name,
                    image: (data.data.images || []).length > 0 ? BASE_URL + data.data.images[0].url : 'https://picsum.photos/400/250?random=93812093',
                    // watering: {
                    //     frequency: `${data.data.watering[0].timesPerDay} مرتبه در روز`,
                    //     timeOfDay: data.data.watering[0].frequencyType == 'daily' ? 'روزانه' : 'هر چند روز',
                    //     tips: `برای گلدان با سایز ${data.data.watering[0].potSize} و نوردهی ${data.data.watering[0].requiredLight.duration_hours} `,
                    //     types: data.data.watering.length
                    // },
                };

                setMobile(data.phone)
                setReminderChannels(data.reminderChannels);


                findLocationByPhone(data.phone);


                setWeather(data.weather);


                setPlant(obj);
                setEligible(true); // فرض می‌کنیم مجاز است
            })
            .catch(err => {
                console.log(err)
                setEligible(false); //   مجاز نیست

            })
            .finally(() => {
                setLoading(false);
                hideLoading();
            });


    }, [plantId, location]);

    const handleLoadLocation = () => {

        getUserLocation()
            .then(data => {
                console.log(data)
                setLocation(data)
            })
            .catch(err => {
                console.warn(err)
                setLocation(err)

            })
            .finally(() => {

            });

    }

    const handleSave = () => {

        if (reminderName.length < 2) {
            setMessage('لطفاً یک نام برای یادآور انتخاب کنید.');
            return;
        }


        if (!channels.sms && !channels.whatsapp && !channels.bale /*&& !channels.telegram*/) {
            setMessage('لطفاً حداقل یک روش یادآوری را انتخاب کنید.');
            return;
        }



        const reminderPayload = {
            plantId,
            nickname: reminderName,
            notes: reminderNote,
            potSize,
            //wateringSettings: {}, // get from server side
            location: {
                latitude: location.latitude || province.lat || 0,
                longitude: location.longitude || province.lng || 0,
            },
            lastWateredIndexDay: lastWateredIndexDay,

            channels: Object.entries(channels)
                .filter(([_, v]) => v)
                .map(([k]) => k),
        };

        showLoading();

        addUserPlant(reminderPayload)
            .then(data => {

                if (data.status == 400 || data.hasError || (data.message && data.message.indexOf('upgrade') != -1)) {

                    setEligible(false); //   مجاز نیست
                    // setLoading(false);
                    setPlant({ "message": data.message });
                    return;
                }

                toast.success('یادآور با موفقیت ثبت شد!');

                navigate(`/reminders?p=${data._id}`);
            })
            .catch(err => {
                console.log(err)
                toast.error('خطایی رخ داد. در صورت تکرار با مدیر سایت تماس بگیرید');

            })
            .finally(() => {
                setLoading(false);
                hideLoading();
            });


        console.log('Reminder saved:', reminderPayload);

        setMessage('');

    };

    if (loading || (!plant)) {
        return <div className="text-center mt-5">در حال بارگذاری...</div>;
    }

    if (!eligible) {
        return (
            <div className="container mt-4">

                <Alert variant="warning">
                    شما مجاز به ثبت یادآور برای این گیاه نیستید. لطفاً{' '}
                    <Alert.Link href={`/plans?backTo=${plantId}`}>پلن اشتراکی</Alert.Link>  خود را ارتقا دهید تا سقف تعداد گیاهان شما افزایش یابد.
                </Alert>

                <div className='mb-1 text-center'>
                    <img src={onlineShopping} alt="pay for plans" width={256} />
                    <br/>

                      <Alert.Link href={`/plans?backTo=${plantId}`}
                      className='btn btn-info'>
                          سفارش پلن جدید
                      </Alert.Link>

                 


                </div>

            </div>
        );
    }

    return (
        <div className="container mt-4">
            <Card className="mb-4">
                <Card.Body>
                    <Card.Title>{plant.name}</Card.Title>

                    <Row>
                        <Col md={3}>
                            <Card.Img src={plant.image} alt={plant.name} className="mb-3" />
                        </Col>
                        <Col>
                            <Card.Text>{plant.description}</Card.Text>
                        </Col>
                    </Row>


                    {/* 
                    <strong>زمان‌بندی آبیاری:</strong>
                    <ul>
                        <li>تکرار: {plant.watering.frequency}</li>
                        <li>ساعت مناسب: {plant.watering.timeOfDay}</li>
                        <li>نکات: {plant.watering.tips}</li>
                        <li>تنوع آبیاری: {plant.watering.types} مدل
                            {plant.watering.types > 1 ? ' (بسته به سایز گلدان و آب و هوا و...) ':'' }
                        </li>
                    </ul> */}
                </Card.Body>
            </Card>

            <h5 className="mb-3">تنظیم یادآور</h5>
            {message && <Alert variant="danger">{message}</Alert>}

            <Form>

                <Row>

                    <Col xs={12} md={4} >
                        <Form.Group className="mb-3">
                            <Form.Label>نام دلخواه برای گیاه</Form.Label>
                            <Form.Control
                                type="text"
                                value={reminderName}
                                onChange={(e) => setReminderName(e.target.value)}
                                placeholder="مثلاً گلدون کنار پنجره"
                            />
                        </Form.Group>

                    </Col>


                    <Col xs={12} md={4} >

                        <Form.Group className="mb-3">
                            <Form.Label>   {t("console.plant.watering.potSize_title")}     </Form.Label>

                            <select
                                className="form-select"
                                value={potSize}
                                onChange={(e) => setPotSize(e.target.value)} >
                                <option value="xsmall">   {t("console.plant.watering.potSize_xsmall")}       </option>
                                <option value="small">   {t("console.plant.watering.potSize_small")}        </option>
                                <option value="medium">  {t("console.plant.watering.potSize_medium")}        </option>
                                <option value="large">    {t("console.plant.watering.potSize_large")}         </option>
                                <option value="xlarge">   {t("console.plant.watering.potSize_xlarge")}        </option>
                            </select>

                        </Form.Group>


                    </Col>

                    <Col xs={12} md={4} >

                        <Form.Group className="mb-3">
                            <Form.Label>
                                روش یادآوری به
                                {' '} {mobile}
                            </Form.Label>
                            <div className="d-flex gap-3">


                                <Form.Check
                                    type="checkbox"
                                    label="پیامک"
                                    checked={channels.sms}
                                    onChange={() => setChannels({ ...channels, sms: !channels.sms })}
                                />

                                {reminderChannels.whatsapp_chat_id &&
                                    <Form.Check
                                        type="checkbox"
                                        label="واتس‌اپ"
                                        checked={channels.whatsapp}
                                        onChange={() =>
                                            setChannels({ ...channels, whatsapp: !channels.whatsapp })
                                        }
                                    />}

                                {/* {!reminderChannels.whatsapp_chat_id &&
                                    <a className='btn btn-sm btn-primary disabled'
                                        href='#SOON'
                                        title='به زودی'
                                        target='_blank'>
                                        فعال سازی اتصال به واتس آپ
                                    </a>
                                } */}

                                {reminderChannels.bale_chat_id &&
                                    <Form.Check
                                        type="checkbox"
                                        label="بله"
                                        checked={channels.bale}
                                        onChange={() =>
                                            setChannels({ ...channels, bale: !channels.bale })
                                        }
                                    />}

                                {!reminderChannels.bale_chat_id &&
                                    <a className='btn btn-sm btn-primary'
                                        href={reminderChannels.bale_join_url}
                                        target='_blank'>
                                        فعال سازی اتصال به بله
                                    </a>
                                }


                                {/* <Form.Check
                                    type="checkbox"
                                    label="تلگرام"
                                    checked={channels.telegram}
                                    onChange={() =>
                                        setChannels({ ...channels, telegram: !channels.telegram })
                                    }
                                /> */}
                            </div>
                        </Form.Group>

                    </Col>



                </Row>



                <Row>

                    <Col md={4} xs={12} >
                        {/* <Button variant="primary" onClick={handleLoadLocation}>
                                نمایش موقعیت جغرافیایی
                             </Button> */}
                        <Form.Label> استان و ناحیه جغرافیایی
                            {weather && <span>
                                {' ( ' + weather.temperature_c + ' °C ' + (weather?.location?.city) + ') '}
                            </span>}

                        </Form.Label>

                        <ProvinceSelect value={province} onChange={setProvince} />

                    </Col>


                    <Col xs={12} md={4} >
                        <Form.Group className="mb-3">
                            <Form.Label>
                                آخرین آبیاری
                            </Form.Label>
                            <select className='form-select' name='lastWateredIndexDay'
                                value={lastWateredIndexDay}
                                onChange={(e) => setLastWateredIndexDay(Number(e.target.value))}>
                                <option value={-1}> هنوز شروع نکرده ام </option>
                                <option value={0}> امروز آب دادم</option>
                                <option value={1}> دیروز آب دادم</option>
                                <option value={2}> پریروز آب دادم</option>
                            </select>
                            {/* <Form.Control
                                        as="select"
                                        rows={2}
                                        value={reminderNote}
                                        maxLength={500}
                                        onChange={(e) => setReminderNote(e.target.value)}
                                    /> */}
                        </Form.Group>

                    </Col>
                    <Col xs={12} md={4} >
                        <Form.Group className="mb-3">
                            <Form.Label>یادداشت کوتاه</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                value={reminderNote}
                                maxLength={500}
                                onChange={(e) => setReminderNote(e.target.value)}
                            />
                        </Form.Group>

                    </Col>

                </Row>










                <div className="mt-4 d-flex justify-content-between">
                    <Button variant="success" onClick={handleSave}>
                        ذخیره یادآور
                    </Button>

                    <Button variant="secondary" onClick={() => navigate(-1)}>
                        بازگشت
                    </Button>

                </div>
            </Form>
        </div>
    );
};

export default PlantReminderPage;
